import { cleanFilters, RECORD_ID, withFilters } from '@/features/common/listingFilters';
import type { AdvisorFilterName } from '@/features/publicsite/types/registry/AdvisorFilterName';

const FILTER_NAMES: AdvisorFilterName[] = ['q', 'domain'];

function acceptable(name: AdvisorFilterName, value: string): boolean {
  // The endpoint answers 400 to a `domain` that is not a UUID, so a mangled or hand-edited link
  // would blank the registry rather than be ignored — the same guard the calendar's lists carry.
  return name === 'domain' ? RECORD_ID.test(value) : true;
}

/**
 * The filters /consilieri's URL holds, cleaned: trimmed, blanks left out, and the domain only when
 * it is an id the endpoint can take. The request, the reset button and the tags all read the URL
 * through this, so none of them can disagree about what is being filtered.
 */
export function advisorFilters(
  params: URLSearchParams,
): Partial<Record<AdvisorFilterName, string>> {
  return cleanFilters(params, FILTER_NAMES, acceptable);
}

/** The URL after a change to some of the filters, the rest kept as they stand. */
export function withAdvisorFilters(
  params: URLSearchParams,
  changes: Partial<Record<AdvisorFilterName, string | null>>,
): URLSearchParams {
  return withFilters(params, changes, advisorFilters);
}
